// extracted by mini-css-extract-plugin
export var bodySections = "_au-8";
export var gray = "_au-7";
export var green = "_au-4";
export var iconContainer = "_au-9";
export var iconWidgetContainer = "_au-1";
export var phoneIcon = "_au-2";
export var red = "_au-5";
export var statusDot = "_au-3";
export var widgetContainer = "_au-0";
export var yellow = "_au-6";